module.exports = __webpack_public_path__ + "img/voidv1.a893297d.png";